import { initPostHog } from '@ballz-app/analytics';

import { useInitializeWallet } from './useInitializeWallet';

export const useInitializeApp = () => {
  useInitializeWallet();
  initPostHog();
};
